import React from "react";
import styled from "styled-components";

const AffiliationSection = ({ formData, handleChange, countryList }) => {
    return (
        <Container>
        <div className="address-section">
            <h4>Affiliation Address</h4>
            
            <div className="form-row">
                <div className="form-column">
                    <label htmlFor="affiliation_address_street">Street*</label>
                    <input 
                        type="text" 
                        id="affiliation_address_street" 
                        name="affiliation_address_street" 
                        required 
                        value={formData.affiliation_address_street} 
                        onChange={handleChange}
                    />
                </div>
                <div className="form-column">
                    <label htmlFor="affiliation_address_city">City*</label>
                    <input 
                        type="text" 
                        id="affiliation_address_city" 
                        name="affiliation_address_city" 
                        required 
                        value={formData.affiliation_address_city} 
                        onChange={handleChange}
                    />
                </div>
                <div className="form-column">
                    <label htmlFor="affiliation_address_country">Country*</label>
                    <select 
                        id="affiliation_address_country" 
                        name="affiliation_address_country" 
                        required 
                        value={formData.affiliation_address_country} 
                        onChange={handleChange}
                    >
                        <option value="">Select Country</option>
                        {countryList.map((country, index) => (
                            <option key={index} value={country}>{country}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
        </Container>
    );
};


const Container = styled.div`
    .address-section {
        border: 1px solid #eee;
        padding: 1.2em;
        border-radius: 8px;
        margin-top: 1em;
        margin-bottom: 1.5em;
        
        h4 {
            margin-top: 0;
            border-bottom: none;
            padding-bottom: 0.2em;
        }
    }
`;

export default AffiliationSection;